import { render, staticRenderFns } from "./personModel.vue?vue&type=template&id=0bab164e&scoped=true"
import script from "./personModel.vue?vue&type=script&lang=js"
export * from "./personModel.vue?vue&type=script&lang=js"
import style0 from "./personModel.vue?vue&type=style&index=0&id=0bab164e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bab164e",
  null
  
)

export default component.exports